import styled from "@emotion/styled";
import { Content } from "src/atoms/Content";

export const ContentContainer = styled(Content)`
  display: grid;
  grid-template-columns: 100%;
  row-gap: ${({ theme }) => theme.space?.space24};
  padding-block: ${({ theme }) => theme.space?.space32};
  min-width: 0;
  min-height: 100vh;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space?.space24};
`;

export const MiscContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space?.space16};
`;

export const SkeletonContainer = styled(Content)`
  background-color: ${({ theme }) => theme.colors?.tone.white};
  width: 100vw;
  display: grid;
  grid-template-columns: 1fr;
  row-gap: ${({ theme }) => theme.space?.space24};
  padding-block: ${({ theme }) => theme.space?.space32};
`;
